
import axios from 'axios';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import LiveAgentMessage from '../../components/ticketing/LiveAgentMessage.vue';

@Component({ components: { LiveAgentMessage } })
export default class TicketThread extends Vue {
  @Prop({ required: true }) ticketId!: string;

  messages: any[] = [];
  loading = false;
  error = false;
  // Toggled false→true after each load so LiveAgentMessage's `loadHeight`
  // watcher fires and sizes the sandboxed iframes to their content.
  heightReady = false;

  created() {
    this.load();
  }

  @Watch('ticketId')
  onTicketChange() {
    this.load();
  }

  async load() {
    if (!this.ticketId) {
      this.messages = [];
      return;
    }
    this.loading = true;
    this.error = false;
    this.heightReady = false;
    try {
      const { data } = await axios.get(
        `/data-api/ticket/${this.ticketId}/messages`,
      );
      this.messages = Array.isArray(data) ? data : [];
      this.$nextTick(() => {
        this.heightReady = true;
      });
    } catch (e) {
      this.error = true;
      this.messages = [];
    } finally {
      this.loading = false;
    }
  }
}
